import React from 'react';

import PropTypes from 'prop-types';
import cn from 'classnames';

// add active element and active className,
function Tracker({
  data,
  borderStyle,
  borderColor,
  finalIcon,
  activeFinalIcon,
  activeIcon,
  inActiveIcon,
  inActiveColor,
  animateOff,
}) {
  const renderIcon = (isActive, key) => {
    const isFinal = key === data?.length - 1;

    if (isActive && !isFinal)
      return (
        <div className={cn(!animateOff ? 'animate-pulse' : '')}>
          {activeIcon}
        </div>
      );

    if (isFinal) {
      if (isActive) {
        if (activeFinalIcon) {
          return activeFinalIcon;
        }

        if (finalIcon) {
          return (
            <div className={cn(!animateOff ? 'animate-pulse' : '')}>
              {finalIcon}
            </div>
          );
        }

        return (
          <div className={cn(!animateOff ? 'animate-pulse' : '')}>
            {activeIcon}
          </div>
        );
      }

      if (!isActive && finalIcon) {
        return finalIcon;
      }
    }

    if (inActiveIcon) return inActiveIcon;

    return <div className={cn('w-5 h-5 rounded-full', inActiveColor)} />;
  };

  return (
    <div className="space-y-6">
      {data?.map(({ id, isActive, title, description }, key) => (
        <div className="flex -ml-3 gap-1" key={id}>
          <div className="flex justify-center items-start relative w-12">
            {/* border */}
            {key !== data?.length - 1 && (
              <>
                <div
                  className={cn(
                    `h-full absolute border-[1px] top-0 left-6/12`,
                    borderColor,
                    borderStyle
                  )}
                />
                <div
                  className={cn(
                    `h-[27px] absolute border-[1px] bottom-[-24px] left-6/12`,
                    borderColor,
                    borderStyle
                  )}
                />
              </>
            )}

            <div className="bg-white z-10">{renderIcon(isActive, key)}</div>
          </div>
          <div className="flex-1 space-y-1 !leading-snug">
            <div
              className={cn(
                'font-semibold text-sm',
                isActive ? 'text-black' : 'text-gray-700 text-opacity-50'
              )}
            >
              {title}
            </div>
            <div
              className={cn(
                'font-light text-xs',
                isActive ? 'text-black' : 'text-gray-700 text-opacity-50'
              )}
            >
              {description}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

Tracker.defaultProps = {
  data: [],
  borderStyle: '',
  finalIcon: '',
  activeFinalIcon: '',
  inActiveColor: 'bg-primary-500',
  borderColor: 'border-primary-500',
  activeIcon: (
    <div className="w-5 h-5 bg-primary-500 rounded-full border-5 border-primary-100" />
  ),
  inActiveIcon: '',
  animateOff: false,
};

Tracker.propTypes = {
  borderStyle: PropTypes.string,
  borderColor: PropTypes.string,
  inActiveColor: PropTypes.string,
  data: PropTypes.instanceOf(Array),
  activeIcon: PropTypes.instanceOf(Object),
  inActiveIcon: PropTypes.oneOfType([
    PropTypes.instanceOf(Object),
    PropTypes.string,
  ]),
  finalIcon: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  activeFinalIcon: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  animateOff: PropTypes.bool,
};

export default React.memo(Tracker);
